export default {
  BASE_API_URL: '/api',
};



// WEBPACK FOOTER //
// ./src/config/config.default.js